import { Tabs, TabsProps } from "antd"
import RegularPledge from "./components/regularPledge";
import History from "./components/history";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ContractHash = () => {
    const { t } = useTranslation();
    const [keys, setKeys] = useState('1')
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: t('contract.contractHashrate')
        },
        {
            key: '2',
            label: t('contract.myBill'),
        }
    ];
    return (
        <div className="max-w-[600px] mx-auto">
            <Tabs centered className="box-border pl-5.25 bg-transparent" defaultActiveKey={keys} items={items} onChange={(key: string) => { setKeys(key) }} />
            {keys === '1' && <RegularPledge />}
            {keys === '2' && <History />}
        </div>
    )
}

export default ContractHash